export class EnvConfiguration {
  forumUrl = ''
  widgetUrl = ''
  loginUrl = ''
  loginDarkModeParam = ''
  subscriptionUrl = '' // VUE_APP_PROD_BUY_SUBSCRIPTION_URL
  premiumSubscriptionUrl = '' // VUE_APP_PROD_PREMIUM_SUBSCRIPTION_URL
  mySubscriptionUrl = '' // VUE_APP_PROD_MY_SUBSCRIPTION_URL
  codexUrl = ''
  newsletterManagementUrl = ''
  userEditUrl = ''
  gdprEmailContact = ''
}
